import React from "react";
import { Box } from "@mui/material";

import { flowLogoUrl } from "../consts";

const Headline = () => {
    return (
        <Box
            component="img"
            src={flowLogoUrl}
            sx={{
                width: {
                    xs: "130px",
                    sm: "260px",
                },
                height: {
                    xs: "65px",
                    sm: "130px",
                },
            }}
        />
    );
};

export default Headline;
